// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'nprogress/nprogress.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import './assets/custom.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import Vue from 'vue';
import App from './App';
import router from '@/router';
import http from './services/http';
import moment from 'moment';

import AlertMessage from '@/components/custom/AlertMessage';
Vue.component('alertMessage', AlertMessage);

import Atividade from '@/components/custom/Atividades';
Vue.component('atividades', Atividade);

import 'vue-multiselect/dist/vue-multiselect.min.css';
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import TipoEspecial from '@/components/custom/TipoEspecial';
Vue.component('tipoEspecial', TipoEspecial);

import money from 'v-money';
Vue.use(money, {
  precision: 2
});

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import store from '@/store';

Vue.mixin({
  data() {
    return {
      api: ''
    }
  },
  beforeMount() {
    this.token = store.state.token;
    this.jwt = store.state.jwt;
    this.api = process.env.API_ENV;
  },
  methods: {
    formatar(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss');
    },
    validaModulo(modulo) {
      return this.token.empresaModel && this.token.empresaModel.modulos[modulo]
    }
  },
  computed: {
    isLogged() {
      return store.state.isLogged;
    },
    token: {
      get: function () {
        return store.state.token;
      },
      set: function (newValue) {}
    }
  },
});

import VueNumericInput from 'vue-numeric-input';

Vue.use(VueNumericInput)

import {
  Pagination
} from 'vue-pagination-2';

Vue.component('pagination', Pagination);

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
  iconPack: 'material', // set your iconPack, defaults to material. material|fontawesome
  position: 'top-right',
  duration: 5000,
  theme: 'primary',
  icon: {
    name: 'check',
    after: true // this will append the icon to the end of content
  }
});

import VueSlideoutPanel from 'vue2-slideout-panel';
Vue.use(VueSlideoutPanel);


import bus from '@/BUS';
Vue.component("panel-1", {
  name: "panel-1",
  template: `
  <div class="container">
    <div class="row" style="margin-top: 20px">
      <div class="col">
      <button class="btn btn-danger btn-raised" v-on:click.prevent="closePanel">
        Voltar
      </button>
      <br>
        <div v-if="notificacoes.length <= 0" >
          Você será alertado aqui quando houver algume pendência.
        </div>

        <div v-for="(not, index) in notificacoes">
          <div class="card text-center" >
            <div class="card-header">
              Atenção
              <button @click="fecharNot(index, not)" type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card-body">
              <p class="card-title">{{not.mensagem}}</p>
              <a v-if="not.licenca" :href="getLink(not)" class="btn btn-sm btn-warning btn-raised">+Adicionar protocolo</a>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
`,
  data() {
    return {
      notificacoes: [],
    };
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
      bus.$emit('get-notys');
    },
    getLink(not) {
      let tipo;

      if (not.licenca) tipo = 'ambientais';

      let url = `/compromissos/${tipo}/cooperado/${not.usuario}`;

      return url;
    },
    async fecharNot(index, not) {
      await this.$http.post('/notificacoes/marcarLido', not);
      this.notificacoes.splice(index, 1);
    }
  },
  async beforeMount() {
    const resNotys = await this.$http.post('/notificacoes/list', {});
    this.notificacoes = resNotys.data;
  }
});

Vue.prototype.$http = http;
Vue.config.productionTip = false;

Vue.prototype.$custom = {
  success: {
    type: 'success',
    icon: 'check'
  },
  error: {
    type: 'error',
    icon: 'close'
  },
  pagOpts: {
    chunk: 3,
    texts: {
      count: 'Exibindo do {from} até {to} de {count} registros|{count} registros|1 registro',
      first: 'Primeira',
      last: 'Última'
    }
  }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js